import React from 'react';
import { Instruction } from '@fx-ui/fine-design';
import { Hyperlink } from '@fx-ui/jdy-design-biz';
import { SuiteId } from '~/interfaces';
import { getCurrentLocaleKey } from '~/utils';

interface SuiteLoginTipProps {
    className?: string;
}

const SuiteLoginTip: React.FC<SuiteLoginTipProps> = ({ className }) => {
    const suiteId = window.platform_suite_id ?? SuiteId.PLATFORM;
    const loginTip = window.platform_suite_views?.[suiteId]?.login_tip;
    const localeLoginTip = loginTip?.i18n?.[getCurrentLocaleKey()];
    const text = localeLoginTip?.text || loginTip?.text;
    const linkText = localeLoginTip?.link_text || loginTip?.link_text;
    const linkUrl = loginTip?.link_url;

    if (!loginTip?.is_enabled || !text) {
        return null;
    }

    return (
        <Instruction
            className={className}
            type="info"
            showIcon
            message={
                <>
                    {text}
                    {linkText && linkUrl && (
                        <Hyperlink compact underline={false} target="_blank" href={linkUrl}>
                            {linkText}
                        </Hyperlink>
                    )}
                </>
            }
        />
    );
};

export default SuiteLoginTip;
